import { render, staticRenderFns } from "./resetDefaultPwd.vue?vue&type=template&id=d0d80fec&scoped=true&"
import script from "./resetDefaultPwd.vue?vue&type=script&lang=js&"
export * from "./resetDefaultPwd.vue?vue&type=script&lang=js&"
import style0 from "./resetDefaultPwd.vue?vue&type=style&index=0&id=d0d80fec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d80fec",
  null
  
)

export default component.exports